import get from 'lodash/get';

import byLocationIdReducerFactory from 'locations/reducers/byLocationIdReducerFactory';
import { LOCATION_INVENTORY } from 'locations/constants/entities';
import { getLocationInventoryActionTypes } from 'locations/actions/locationInventory';

const processSuccessPayload = payload => payload.products_with_inventory;
const actionTypes = getLocationInventoryActionTypes().map(
  actionType => actionType.type
);
const locationInventory = byLocationIdReducerFactory(
  LOCATION_INVENTORY,
  actionTypes,
  processSuccessPayload
);

export default locationInventory;

// SELECTORS
export const getProductsWithInventoryForLocation = (
  locationInventory,
  locationId
) => {
  return get(locationInventory, ['byLocationId', locationId], []);
};
